/**
 * "Shop this look" drawer behavior (markup lives in snippets/slideshow-split-content.liquid).
 *
 * This used to be an inline <script> emitted once per hero block that had shop-look products. It now lives in a
 * single cached asset loaded with `defer` from layout/theme.liquid, and uses event delegation so it keeps working
 * for drawers added after load (e.g. when a section is re-rendered in the theme editor).
 */
(function () {
  if (window.__shopLookDrawerInit) return;
  window.__shopLookDrawerInit = true;

  function resetVariantSelects(details) {
    if (!details) return;

    details.querySelectorAll('product-card-variant-select').forEach(function (el) {
      if (typeof el.reset === 'function') {
        el.reset();
      }
    });
  }

  function closeShopLook(details) {
    if (!details) return;

    document.body.classList.remove('shop-look-open');
    details.classList.add('is-closing');

    setTimeout(function () {
      details.removeAttribute('open');
      details.classList.remove('is-closing');
      resetVariantSelects(details);
    }, 300); // same as CSS animation time
  }

  /*
   * Lock the page scroll while the drawer is open, and unlock as soon as it closes - however it closes
   * (X button, overlay click, cart:change, or clicking the bag icon again to natively toggle it shut).
   * Uses its own "shop-look-lock" class rather than the theme's shared "lock" class, because the variant
   * dropdown inside is itself a popover that locks/unlocks "lock" through a shared counter on mobile - closing
   * the dropdown would otherwise remove "lock" and re-enable background scroll while the drawer stays open.
   *
   * "toggle" doesn't bubble, hence the capture phase.
   */
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.classList || !details.classList.contains('slideshow__shop-look-toggle')) return;

    document.documentElement.classList.toggle('shop-look-lock', details.open);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    if (target.closest('.slideshow__shop-look-toggle > summary')) {
      document.body.classList.add('shop-look-open');
      return;
    }

    var closeButton = target.closest('.shop-look-close');
    if (closeButton) {
      closeShopLook(closeButton.closest('.slideshow__shop-look-toggle'));
      return;
    }

    var overlay = target.closest('.shop-look-overlay');
    if (overlay) {
      closeShopLook(overlay.closest('.slideshow__shop-look-toggle'));
    }
  });

  /*
   * Close the drawer only once an item has actually been added to cart (not merely when a quick-add button
   * was clicked - that click may just be revealing the inline "select size/material" dropdowns).
   */
  document.addEventListener('cart:change', function (event) {
    if (!event.detail || event.detail.baseEvent !== 'variant:add') return;

    document.querySelectorAll('.slideshow__shop-look-toggle[open]').forEach(closeShopLook);
  });
})();
